import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { orderBy } from "lodash";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import ContractTypeSelect from "../../common/ContractTypeSelect";
import DropdownSearch from "../../common/DropdownSearch";
import Checkbox from "../../expense/ExpenseApprovalCheckbox";

import { formatDate } from "../../../helpers/date";

import ReportFilters from "../ReportFiltersComponent";

const Filters = ({
  filters,
  onChange,
  codes,
  fetchData,
  handleResetFilters,
  loading,
  exportDisabled,
  onCSVExport,
  onPDFExport
}) => {
  const generateCodeOptions = (entity, field) => {
    const codeOptions = codes
      ?.filter((code) => code.entity === entity && code.field === field)
      ?.map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, [(option) => option.label.toLowerCase()]);
  };

  const startDate = useMemo(
    () => new Date(filters.startDate).setUTCHours(13),
    [filters]
  );
  const endDate = useMemo(
    () => new Date(filters.endDate).setUTCHours(13),
    [filters]
  );

  return (
    <ReportFilters
      onFetchClick={fetchData}
      onResetClick={handleResetFilters}
      title={`Time Tracker from ${formatDate(
        new Date(startDate),
        "MM/dd/yyyy"
      )} to ${formatDate(new Date(endDate), "MM/dd/yyyy")}`}
      loading={loading}
      csvExportAvailable
      pdfExportAvailable
      onCSVExport={onCSVExport}
      onPDFExport={onPDFExport}
      exportDisabled={loading || exportDisabled}
      disabled={
        !filters.startDate || !filters.endDate || !filters.customer || loading
      }
    >
      <Row>
        <Col md={3}>
          <CustomerSelect
            isMulti={false}
            onChange={onChange("customer")}
            required
            placeholder="Select"
            label="Customer *"
            value={filters.customer || null}
          />
        </Col>
        <Col md={3}>
          <ContractTypeSelect
            isMulti
            onChange={onChange("contract_type")}
            value={filters.contract_type || []}
            placeholder="Select"
            label="Contract Type"
          />
        </Col>
        <Col md={3}>
          <DropdownSearch
            rowStyles={{ marginTop: 0 }}
            isMulti
            placeholder="Select"
            name="stage"
            onChange={(name, value) => onChange("stage")(value || [])}
            value={filters.stage || []}
            label="Call Status"
            data={[...generateCodeOptions("Call", "status")]}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            Start Date *
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            value={filters.startDate}
            onChange={(e) => onChange("startDate")(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            End Date *
          </label>
          <input
            style={{
              padding: 8,
              border: "1px solid hsl(0,0%,80%)",
              width: "100%",
              borderRadius: 4
            }}
            type="date"
            value={filters.endDate}
            onChange={(e) => onChange("endDate")(e.target.value)}
          />
        </Col>
        <Col md={3}>
          <div style={{ marginTop: 25, marginLeft: 10 }}>
            <Checkbox
              className="checkbox expense"
              style={{ margin: "0 0", display: "inline" }}
              onClickCheck={(e) => onChange("showNotes")(e.target.checked)}
              checked={!!filters.showNotes}
            />
            <div style={{ display: "inline" }}> Show Work Note</div>
          </div>
        </Col>
        <Col md={3}>
          <div style={{ marginTop: 25, marginLeft: 10 }}>
            <Checkbox
              className="checkbox expense"
              style={{ margin: "0 0", display: "inline" }}
              onClickCheck={(e) => onChange("activeOnly")(e.target.checked)}
              checked={!!filters.activeOnly}
            />
            <div style={{ display: "inline" }}> Active Contracts Only</div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <label
            className="control-label"
            style={{ textTransform: "uppercase" }}
          >
            * Required Fields
          </label>
        </Col>
      </Row>
    </ReportFilters>
  );
};
Filters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  codes: PropTypes.array,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  exportDisabled: PropTypes.bool,
  onCSVExport: PropTypes.func,
  onPDFExport: PropTypes.func
};
export default Filters;
